import React from "react";
import { Leftnav } from "./leftNav.jsx";
import { PopularLinks } from "./popularLinks.jsx";
import { MainHeader } from "../layout/mainHeader.jsx";
import GamesLeftNav from "../casino/v1/leftNAv.jsx";
import { isMobile } from "react-device-detect";

class LeftPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };

        this.leftPanelRef = React.createRef();
    }


    componentDidMount() {
        const { current: leftPanel } = this.leftPanelRef;
        leftPanel.setAttribute("style", "height: 0 !important");
    }

    render() {

        const popularLinksVisible = this.props.config !== undefined && ((this.props.config.events !== undefined && this.props.config.events.length > 0) || (this.props.config.links !== undefined && this.props.config.links.length > 0)); //popular links and left nav share smae area
        const groupData = this.props.groupData || this.props.gamesData || [];
        const eventTreeVisible = this.props.eventClassifiers !== undefined;

        const eventClassifiers = this.props.eventClassifiers;
        if (this.props.isBlockedFromGames && GBEglobal.settings.virtualConfig) {
            const virtualEventClassifier = eventClassifiers.find((o) => parseInt(o.eventClassifierId, 10) === parseInt(GBEglobal.settings.virtualConfig.virtuals, 10));
            const virtualIndex = eventClassifiers.indexOf(virtualEventClassifier);
            if (virtualIndex > -1) {
                eventClassifiers.splice(virtualIndex, 1);
            }

        }
        return (
            <div className={this.props.isCasino && !isMobile ? "col-12" : "leftPanel"} ref={this.leftPanelRef}>
                {!this.props.isCasino &&
                    <MainHeader modes={this.props.modes}
                        fromLeftNav={true}
                    />
                }

                {groupData.length > 0 && isMobile &&
                    <>
                        <GamesLeftNav
                            groupData={groupData}
                            favouritesData={this.props.favouritesData}
                            userContext={this.props.userContext}
                            togglePanel={this.props.togglePanel}
                            showCasinoSearchPopup={this.props.showCasinoSearchPopup}
                            searchResults={this.props.searchResults}
                            onSearch={this.props.onSearch}
                            recommendedGames={this.props.recommendedGames}
                            cdnLocation={this.props.cdnLocation}
                            gamesIndex={this.props.gamesIndex}
                            onUpdateFavourites={this.props.onUpdateFavourites}
                            onPlayGame={this.props.onPlayGame}
                            controller={this.props.controller}
                        />
                        <hr />
                    </>
                }

                {groupData.length > 0 && !isMobile &&
                    <GamesLeftNav
                        groupData={groupData}
                        favouritesData={this.props.favouritesData}
                        userContext={this.props.userContext}
                        togglePanel={this.props.togglePanel}
                        searchResults={this.props.searchResults}
                        onSearch={this.props.onSearch}
                        recommendedGames={this.props.recommendedGames}
                        cdnLocation={this.props.cdnLocation}
                        gamesIndex={this.props.gamesIndex}
                        onUpdateFavourites={this.props.onUpdateFavourites}
                        onPlayGame={this.props.onPlayGame}
                        controller={this.props.controller}
                    />
                }

                {eventTreeVisible && popularLinksVisible &&
                    <>
                        <PopularLinks
                            config={this.props.config}
                            controller={this.props.controller}
                            onShowModal={this.props.onShowModal}
                            isBlockedFromGames={this.props.isBlockedFromGames}
                            togglePanel={this.props.togglePanel}
                            eventClassifiers={eventClassifiers} />
                        <hr />
                    </>
                }
                {eventTreeVisible &&
                    <Leftnav rootOnly={isMobile && GBEglobal.settings.generalConfig && GBEglobal.settings.generalConfig.rootOnly}
                        isSharedSpace={popularLinksVisible}
                        eventClassifiers={eventClassifiers}
                        activeEventClassifier={this.props.leftNavEventClassifier}
                        controller={this.props.controller}
                        onAllSportsClicked={this.props.onAllSportsClicked}
                        togglePanel={this.props.togglePanel}
                        isEventCard={this.props.isEventCard}
                        getGroupMarkets={this.props.getGroupMarkets}
                        history={this.props.history}
                        isBlockedFromGames={this.props.isBlockedFromGames}
                    />
                }
            </div>
        );
    }
}

export { LeftPanel };